// ./store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var state = {
  OverReplacement: 2,
  UseDHflag: false,
  loading: false,
  suggestionList: [],
  inputYear: [],
  inputTeam: [],
  inputCategory: [],
  inputName: '',
  InputNTList: {},
  nenList: [],
  result: undefined,
  LineUp: [],
  LineUpSetting :{},
  GameRange: 143,
  YearRange: 100,
  users: [],
  SeachFilter: {},
  result_players: [],
  selectedPoss: [],
  inputedPoss: {},
  targetPos: true,
  targetMatchName: false,
  blank: { id: 'blank', title: '' },
  result_sim: {
    yearlen: 0,
    gamelen: 0,
    scores: [[0]],
    player_total: [0],
    re_result: {Expected: {}, Probability: {}},
    re_flag: true,
    EvIncidence: {},
    scores_data: [],
    chart_data: {},
  },
  UseRE: false,
  TabActive: 'sim',
  AppTitle: '打線シミュレーター',
  LoadingFlag: false,
  LockEnter: false,
  SH_use: true,
}

const actions = {
  done ({ state, commit }) {
    // state.routeでアクセス可能
    console.log('actions:', state.route.params.id)
    commit('done')
  },
  setValue (context, {vals, keyname}) {
    context.commit('updateValue', {vals, keyname})
  }
}

const mutations = {
  done (state) {
    // state.routeでアクセス可能
    console.log('mutations:', state.route.params.id)
  },
  updateValue (state, { vals, keyname }) {
    state[keyname] = vals
  },
  updateArrays (state, { vals, array, index }) {
    state[array][index] = vals
  }
}

const getters = {
  list: state => state.list,
  detail: state => {
    // state.routeでアクセス可能
    return state.list.find(l => l.id.toString() === state.route.params.id.toString()) || {}
  },
}
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js